import { AxiosResponse } from "axios";
import { IBulkOrdersResponse, IBulkOrderWithItems } from "domain/BulkOrders";
import { httpApi } from "./http.api";
import { IScheduledDate, IScheduledDatesResponse, ISitesResponse } from "domain/ClientBulkOrders";

const fetchBulkOrders = async (
  baseUrl: string,
  queryParams: Record<string, string | undefined>
): Promise<AxiosResponse<IBulkOrdersResponse>> => {
  const query = Object.entries(queryParams)
    .filter(([_, value]) => value && value !== "All")
    .map(([key, value]) => `${key}=${encodeURIComponent(value!)}`)
    .join("&");

  const url = `${baseUrl}?${query}`;
  const response = await httpApi.get(url);

  const parsedData = response.data.data.map((order: IBulkOrderWithItems) => ({
    ...order,
    recurrent_bulk_order_items: order.recurrent_bulk_order_items
      ? JSON.parse(order.recurrent_bulk_order_items)
      : [],
  }));

  return {
    ...response,
    data: {
      ...response.data,
      data: parsedData,
    },
  };
};

export const getBulkOrdersByDate = async (params: {
  selected_date: string;
  document?: string;
  workSchedule?: string;
}): Promise<AxiosResponse<IBulkOrdersResponse>> => {
  return fetchBulkOrders("BulkOrders/GetBulkOrdersByDate", {
    selected_date: params.selected_date,
    document: params.document,
    work_schedule: params.workSchedule,
  });
};

export const getBulkOrdersByDateForClients = async (params: {
  selected_date: string;
}): Promise<AxiosResponse<IBulkOrdersResponse>> => {
  return fetchBulkOrders("ClientBulkOrders/GetBulkOrdersByDate", {
    selected_date: params.selected_date,
  });
};

export const updateBulkOrders = async (data: {
  selected_date: string;
  bulk_order_items: {
    recurrent_bulk_order_id: number;
    sku_id: number;
    final_by_account_amount?: number | string;
  }[];
}): Promise<AxiosResponse<IBulkOrdersResponse>> => {
  return httpApi.put("ClientBulkOrders", data);
};

export const getWorkScheduleDates = () =>
  httpApi
    .get<IScheduledDatesResponse>(`ClientBulkOrders/GetWorkScheduleDates`)
    .then((response) => response.data.data.map((item: IScheduledDate) => ({
      scheduled_date: item.scheduled_date.split("T")[0],
    })));

export const getSitesData = () =>
  httpApi
    .get<ISitesResponse>(`ClientsData/Sites`)
    .then((response) => response.data.data);